module.exports = __webpack_public_path__ + "static/img/4.c3d9315.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/4.png
// module id = i+85
// module chunks = 0